import axios from 'axios';
import Instense from './Axios-config';
import { API_ROOT } from "./Api-config";


export class ReportServices {
  public static runAccountingReport = async (): Promise<any | null> => {
    let reportparm: any = [];
    reportparm = JSON.parse(localStorage.getItem("reportParameters")!);
    const jsonReportParameters = JSON.stringify(reportparm);
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let username = storage === null || storage === undefined ? 0 : storage.userName;
    let rolId = storage === null || storage === undefined ? 0 : storage.rolId;
    let bodyFormData = new FormData();
    bodyFormData.append('jsonReportParameters', jsonReportParameters);
    bodyFormData.append('username', username);
    bodyFormData.append('rolId', rolId);

    return axios.post(`${API_ROOT.reportingHost}/ReportViewer/RunAccountingReport`, bodyFormData).then((response) => {
      return response.data;
    }).catch((error) => {
      console.log("Error", error);
    });
  }

  
}